import React from 'react';
import { Grid, Link, Box } from '@mui/material';
import { sxStyle } from './styles';
import instagram from '@shared/assets/footer/instagram.svg';
import facebook from '@shared/assets/footer/facebook.svg';
import whatsapp from '@shared/assets/footer/whatsapp.svg';

const FooterRightLinks = ({ pageConfiguration }) => (
  <Grid item xs={12} lg={2} sx={sxStyle.footerSectionsContainer2}>
    <Box sx={sxStyle.externalLinks}>
      {/* Logo AFIP */}
      <Box
        sx={{ ...sxStyle.socialMediaContainer, justifyContent: 'flex-start' }}
      >
        <Link
          href={pageConfiguration.link_afip}
          target="_F960AFIPInfo"
          underline="none"
        >
          <Box
            component="img"
            src={pageConfiguration.site_logos.logoAfip}
            sx={sxStyle.footer_imgDataFiscal}
          />
        </Link>
      </Box>

      {/* Redes Sociales */}
      <Box
        sx={{
          ...sxStyle.socialMediaContainer,
          justifyContent: 'flex-end',
          alignSelf: 'end',
          gap: { xs: 1, md: 2 },
        }}
      >
        {pageConfiguration.link_instagram && (
          <Link
            href={pageConfiguration.link_instagram}
            target="_blank"
            rel="noopener"
          >
            <Box
              component="img"
              src={instagram}
              sx={sxStyle.footer_redesIcono}
            />
          </Link>
        )}
        {pageConfiguration.link_facebook && (
          <Link
            href={pageConfiguration.link_facebook}
            target="_blank"
            rel="noopener"
          >
            <Box
              component="img"
              src={facebook}
              sx={sxStyle.footer_redesIcono}
            />
          </Link>
        )}
        {pageConfiguration.link_whatsapp && (
          <Link
            href={pageConfiguration.link_whatsapp}
            target="_blank"
            rel="noopener"
          >
            <Box
              component="img"
              src={whatsapp}
              sx={sxStyle.footer_redesIconoLast}
            />
          </Link>
        )}
      </Box>
    </Box>
  </Grid>
);

export default FooterRightLinks;
